module.exports = __webpack_public_path__ + "img/运单签收.cbe6c39f.svg";